import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
});

const getCustomers = async () => {
  const response = await axios.get(`${API_URL}customers`, { headers: authHeaders() });
  return response.data;
};

const showCustomer = async (id) => {
  const response = await axios.post(`${API_URL}customers/show`, { id }, { headers: authHeaders() });
  return response.data;
};

const createCustomer = async (data) => {
  const response = await axios.post(`${API_URL}customers/create`, data, { headers: authHeaders() });
  return response.data;
};

const updateCustomer = async (data) => {
  const response = await axios.post(`${API_URL}customers/update`, data, { headers: authHeaders() });
  return response.data;
};

const deleteCustomer = async (id) => {
  const response = await axios.post(`${API_URL}customers/delete`, { id }, { headers: authHeaders() });
  return response.data;
};

export default {
  getCustomers,
  showCustomer,
  createCustomer,
  updateCustomer,
  deleteCustomer,
};